// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var URLCommand$SmartcutsMacros = require("./commands/URLCommand.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var TypeCommand$SmartcutsMacros = require("./commands/TypeCommand.bs.js");
var ClickCommand$SmartcutsMacros = require("./commands/ClickCommand.bs.js");
var RadioCommand$SmartcutsMacros = require("./commands/RadioCommand.bs.js");
var SelectCommand$SmartcutsMacros = require("./commands/SelectCommand.bs.js");
var SwitchCommand$SmartcutsMacros = require("./commands/SwitchCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var CheckboxCommand$SmartcutsMacros = require("./commands/CheckboxCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var ClickInputCommand$SmartcutsMacros = require("./commands/ClickInputCommand.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("./semantics/InnerTextSemantic.bs.js");
var ContextMenuCommand$SmartcutsMacros = require("./commands/ContextMenuCommand.bs.js");
var URLRelatedCommands$SmartcutsMacros = require("./commands/shared/URLRelatedCommands.bs.js");
var ClickToOAuthCommand$SmartcutsMacros = require("./commands/ClickToOAuthCommand.bs.js");
var CopyImageSrcCommand$SmartcutsMacros = require("./commands/CopyImageSrcCommand.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var PasteInInputCommand$SmartcutsMacros = require("./commands/PasteInInputCommand.bs.js");
var NewTabWithUrlCommand$SmartcutsMacros = require("./commands/NewTabWithUrlCommand.bs.js");
var CopyLinkAddressCommand$SmartcutsMacros = require("./commands/CopyLinkAddressCommand.bs.js");
var MoveInputCursorCommand$SmartcutsMacros = require("./commands/MoveInputCursorCommand.bs.js");
var NewWindowWithUrlCommand$SmartcutsMacros = require("./commands/NewWindowWithUrlCommand.bs.js");
var SelectionRelatedCommands$SmartcutsMacros = require("./commands/shared/SelectionRelatedCommands.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var CommandProcessing__DataRef$SmartcutsMacros = require("./CommandProcessing__DataRef.bs.js");
var Selection__StrictSelection$SmartcutsMacros = require("./Selection/Selection__StrictSelection.bs.js");
var ScreenshotToClipboardCommand$SmartcutsMacros = require("./commands/ScreenshotToClipboardCommand.bs.js");
var InnerTextSemanticAuthoringConfig$SmartcutsMacros = require("./semantics/InnerTextSemanticAuthoringConfig.bs.js");
var MoveContentEditableCursorCommand$SmartcutsMacros = require("./commands/MoveContentEditableCursorCommand.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");

function stringifyConfig(config) {
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        return "AddTextInputConfig(_)";
    case /* DeleteTextInputConfig */1 :
        return "DeleteTextInputConfig(_)";
    case /* InnerTextConfig */2 :
        return "InnerTextConfig(_)";
    case /* CheckboxConfig */3 :
        return "CheckboxConfig(_)";
    case /* SelectInputConfig */4 :
        return "SelectInputConfig(_)";
    case /* RadioInputConfig */5 :
        return "RadioInputConfig(_)";
    case /* URLConfig */6 :
        return "URLConfig(_)";
    case /* CopyLinkAddressConfig */7 :
        return "CopyLinkAddressConfig(_)";
    case /* CopyImageSrcConfig */8 :
        return "CopyImageSrcConfig(_)";
    case /* SelectionConfig */9 :
        return "SelectionConfig(_)";
    case /* MoveInputCursorConfig */10 :
        return "MoveInputCursorConfig(_)";
    case /* MoveContentEditableCursorConfig */11 :
        return "MoveContentEditableCursorConfig(_)";
    case /* DownloadConfig */12 :
        return "DownloadConfig(_)";
    case /* GoogleSheetsConfig */13 :
        return "GoogleSheetsConfig(_)";
    case /* ClickInputConfig */14 :
        return "ClickInputConfig(_)";
    case /* PasteInInputConfig */15 :
        return "PasteInInputConfig(_)";
    case /* LoopConfig */16 :
        return "LoopConfig(_)";
    case /* UploadConfig */17 :
        return "UploadConfig(_)";
    case /* WithElementGroupsConfig */18 :
        return "WithElementGroupsConfig(_)";
    
  }
}

function updateConfigWithPlaybackFormLabel(playbackFormLabel, config) {
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        var inputConfig = config._0;
        return {
                TAG: /* AddTextInputConfig */0,
                _0: {
                  targetLocator: inputConfig.targetLocator,
                  originalLabeledAddText: inputConfig.originalLabeledAddText,
                  selectedLabelIndex: inputConfig.selectedLabelIndex,
                  playbackFormLabel: playbackFormLabel,
                  strategy: inputConfig.strategy
                }
              };
    case /* InnerTextConfig */2 :
        return {
                TAG: /* InnerTextConfig */2,
                _0: InnerTextSemanticAuthoringConfig$SmartcutsMacros.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
              };
    case /* CheckboxConfig */3 :
        var inputConfig$1 = config._0;
        return {
                TAG: /* CheckboxConfig */3,
                _0: {
                  checkboxChoice: inputConfig$1.checkboxChoice,
                  playbackFormLabel: playbackFormLabel,
                  dynamic: inputConfig$1.dynamic
                }
              };
    case /* SelectInputConfig */4 :
        var inputConfig$2 = config._0;
        return {
                TAG: /* SelectInputConfig */4,
                _0: {
                  targetLocator: inputConfig$2.targetLocator,
                  originalLabeledValue: inputConfig$2.originalLabeledValue,
                  playbackFormLabel: playbackFormLabel,
                  dynamic: inputConfig$2.dynamic
                }
              };
    case /* RadioInputConfig */5 :
        var inputConfig$3 = config._0;
        return {
                TAG: /* RadioInputConfig */5,
                _0: {
                  targetLocator: inputConfig$3.targetLocator,
                  originalLabeledValue: inputConfig$3.originalLabeledValue,
                  playbackFormLabel: playbackFormLabel,
                  dynamic: inputConfig$3.dynamic
                }
              };
    case /* DownloadConfig */12 :
        return {
                TAG: /* DownloadConfig */12,
                _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
              };
    case /* GoogleSheetsConfig */13 :
        return {
                TAG: /* GoogleSheetsConfig */13,
                _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
              };
    case /* LoopConfig */16 :
        return {
                TAG: /* LoopConfig */16,
                _0: LoopCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
              };
    case /* UploadConfig */17 :
        var func = UploadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel;
        return {
                TAG: /* UploadConfig */17,
                _0: Curry._2(func, config._0, playbackFormLabel)
              };
    case /* WithElementGroupsConfig */18 :
        return {
                TAG: /* WithElementGroupsConfig */18,
                _0: WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithPlaybackFormLabel(playbackFormLabel, config._0)
              };
    default:
      return config;
  }
}

function isDynamic(param) {
  var config = param.config;
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        return Curry._1(TypeCommand$SmartcutsMacros.AuthoringConfig.AddTextInputConfig.isDynamic, config._0);
    case /* DeleteTextInputConfig */1 :
        return Curry._1(TypeCommand$SmartcutsMacros.AuthoringConfig.DeleteTextInputConfig.isDynamic, config._0);
    case /* InnerTextConfig */2 :
        return InnerTextSemanticAuthoringConfig$SmartcutsMacros.isDynamic(config._0);
    case /* CheckboxConfig */3 :
        return CheckboxCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* SelectInputConfig */4 :
        return SelectCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* RadioInputConfig */5 :
        return RadioCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* URLConfig */6 :
        return URLRelatedCommands$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* CopyLinkAddressConfig */7 :
        return CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* CopyImageSrcConfig */8 :
        return CopyImageSrcCommand$SmartcutsMacros.AuthoringConfig.willGenerateAPlaybackParam(config._0);
    case /* SelectionConfig */9 :
        return SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* MoveInputCursorConfig */10 :
        return MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* MoveContentEditableCursorConfig */11 :
        return MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* DownloadConfig */12 :
        return DownloadCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* GoogleSheetsConfig */13 :
        return GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* ClickInputConfig */14 :
        return ClickInputCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* PasteInInputConfig */15 :
        return PasteInInputCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* LoopConfig */16 :
        return LoopCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* UploadConfig */17 :
        return UploadCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    case /* WithElementGroupsConfig */18 :
        return WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.isDynamic(config._0);
    
  }
}

function getAllCommandIndexes(param) {
  return {
          hd: param.firstCommandIndex,
          tl: param.otherCommandIndexes
        };
}

function getLastCommandIndex(param) {
  var otherCommandIndexes = param.otherCommandIndexes;
  if (otherCommandIndexes) {
    return otherCommandIndexes.hd;
  } else {
    return param.firstCommandIndex;
  }
}

function getAllCommandIndexesExceptLast(param) {
  var otherCommandIndexes = param.otherCommandIndexes;
  if (otherCommandIndexes) {
    return List.append(otherCommandIndexes.tl, {
                hd: param.firstCommandIndex,
                tl: /* [] */0
              });
  } else {
    return /* [] */0;
  }
}

function maybeConfigFromCommand(priorCommands, contextGlobal, command) {
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* NewWindowWithUrlCommand */1 :
        return {
                TAG: /* URLConfig */6,
                _0: NewWindowWithUrlCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* NewTabWithUrlCommand */3 :
        return {
                TAG: /* URLConfig */6,
                _0: NewTabWithUrlCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* URLCommand */6 :
        return {
                TAG: /* URLConfig */6,
                _0: URLCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* ClickCommand */12 :
        return Belt_Option.map(Curry._1(ClickCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue, command._0), (function (authoringConfig) {
                      return {
                              TAG: /* InnerTextConfig */2,
                              _0: CommandProcessing__DataRef$SmartcutsMacros.AuthoringConfig.maybeAdjustInnerTextConfigWithDataRefs(priorCommands, authoringConfig)
                            };
                    }));
    case /* ClickInputCommand */13 :
        return Belt_Option.map(ClickInputCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0), (function (config) {
                      return {
                              TAG: /* ClickInputConfig */14,
                              _0: config
                            };
                    }));
    case /* TypeCommand */15 :
        var config = TypeCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0);
        var tmp;
        tmp = config.TAG === /* AddTextInputConfig */0 ? ({
              TAG: /* AddTextInputConfig */0,
              _0: config._0
            }) : ({
              TAG: /* DeleteTextInputConfig */1,
              _0: config._0
            });
        return tmp;
    case /* CheckboxCommand */16 :
        return {
                TAG: /* CheckboxConfig */3,
                _0: CheckboxCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* SelectCommand */17 :
        return {
                TAG: /* SelectInputConfig */4,
                _0: SelectCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* RadioCommand */18 :
        return {
                TAG: /* RadioInputConfig */5,
                _0: RadioCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* MoveInputCursorCommand */22 :
        return {
                TAG: /* MoveInputCursorConfig */10,
                _0: MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* MoveContentEditableCursorCommand */23 :
        return {
                TAG: /* MoveContentEditableCursorConfig */11,
                _0: MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* CopyLinkAddressCommand */25 :
        var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(contextGlobal.url);
        var urlRecord$1;
        if (urlRecord !== undefined) {
          urlRecord$1 = urlRecord;
        } else {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                _1: contextGlobal.url,
                Error: new Error()
              };
        }
        return {
                TAG: /* CopyLinkAddressConfig */7,
                _0: CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(urlRecord$1.origin, command._0)
              };
    case /* SelectionCommand */21 :
    case /* CopyCommand */24 :
    case /* CutCommand */26 :
        break;
    case /* PasteInInputCommand */27 :
        return Belt_Option.map(PasteInInputCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0), (function (config) {
                      return {
                              TAG: /* PasteInInputConfig */15,
                              _0: config
                            };
                    }));
    case /* DownloadCommand */32 :
        return {
                TAG: /* DownloadConfig */12,
                _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* GoogleSheetsCommand */33 :
        return {
                TAG: /* GoogleSheetsConfig */13,
                _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* ContextMenuCommand */34 :
        return Belt_Option.map(Curry._1(ContextMenuCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue, command._0), (function (authoringConfig) {
                      return {
                              TAG: /* InnerTextConfig */2,
                              _0: CommandProcessing__DataRef$SmartcutsMacros.AuthoringConfig.maybeAdjustInnerTextConfigWithDataRefs(priorCommands, authoringConfig)
                            };
                    }));
    case /* LoopCommand */35 :
        return {
                TAG: /* LoopConfig */16,
                _0: LoopCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
              };
    case /* UploadCommand */41 :
        return {
                TAG: /* UploadConfig */17,
                _0: UploadCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
              };
    case /* CopyImageSrcCommand */42 :
        return {
                TAG: /* CopyImageSrcConfig */8,
                _0: CopyImageSrcCommand$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
              };
    case /* WithElementGroupsCommand */43 :
        return {
                TAG: /* WithElementGroupsConfig */18,
                _0: WithElementGroupsCommand$SmartcutsMacros.AuthoringConfig.fromCommandValue(command._0)
              };
    default:
      return ;
  }
  return {
          TAG: /* SelectionConfig */9,
          _0: SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.fromAuthoringCommandValue(command._0)
        };
}

function maybeUpdateConfigWithCommand(command, config) {
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        if (typeof command !== "number" && command.TAG === /* TypeCommand */15) {
          return {
                  TAG: /* AddTextInputConfig */0,
                  _0: Curry._2(TypeCommand$SmartcutsMacros.AuthoringConfig.AddTextInputConfig.updateConfigWithAuthoringCommandValue, command._0, config._0)
                };
        }
        break;
    case /* DeleteTextInputConfig */1 :
        if (typeof command !== "number" && command.TAG === /* TypeCommand */15) {
          return {
                  TAG: /* DeleteTextInputConfig */1,
                  _0: Curry._2(TypeCommand$SmartcutsMacros.AuthoringConfig.DeleteTextInputConfig.updateConfigWithAuthoringCommandValue, command._0, config._0)
                };
        }
        break;
    case /* CheckboxConfig */3 :
        if (typeof command !== "number" && command.TAG === /* CheckboxCommand */16) {
          return {
                  TAG: /* CheckboxConfig */3,
                  _0: CheckboxCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
        }
        break;
    case /* SelectInputConfig */4 :
        if (typeof command !== "number" && command.TAG === /* SelectCommand */17) {
          return {
                  TAG: /* SelectInputConfig */4,
                  _0: SelectCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
        }
        break;
    case /* RadioInputConfig */5 :
        if (typeof command !== "number" && command.TAG === /* RadioCommand */18) {
          return {
                  TAG: /* RadioInputConfig */5,
                  _0: RadioCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
        }
        break;
    case /* DownloadConfig */12 :
        if (typeof command !== "number" && command.TAG === /* DownloadCommand */32) {
          return {
                  TAG: /* DownloadConfig */12,
                  _0: DownloadCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
        }
        break;
    case /* GoogleSheetsConfig */13 :
        if (typeof command !== "number" && command.TAG === /* GoogleSheetsCommand */33) {
          return {
                  TAG: /* GoogleSheetsConfig */13,
                  _0: GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.updateConfigWithAuthoringCommandValue(command._0, config._0)
                };
        }
        break;
    default:
      
  }
  if (typeof command === "number") {
    return config;
  }
  switch (command.TAG | 0) {
    case /* TypeCommand */15 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with TypeCommand was not of type AddTextInputConfig or DeleteTextInputConfig, but was " + (stringifyConfig(config) + (" for command " + Command$SmartcutsMacros.stringifyAuthoringCommand(command))));
    case /* CheckboxCommand */16 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with CheckboxCommand was not of type CheckboxboxConfig");
    case /* SelectCommand */17 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with SelectCommand was not of type SelectInputConfig");
    case /* RadioCommand */18 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with RadioCommand was not of type RadioInputConfig");
    case /* DownloadCommand */32 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with DownloadCommand was not of type DownloadConfig");
    case /* GoogleSheetsCommand */33 :
        return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: the config paired with GoogleSheetsCommand was not of type GoogleSheetsConfig");
    default:
      return config;
  }
}

function registerNewPageForTab(recordingTabId, map) {
  var tabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(recordingTabId);
  return Belt_MapInt.update(map, tabId, (function (maybePageIndexToRest) {
                if (maybePageIndexToRest !== undefined) {
                  return {
                          currentPage: undefined,
                          priorPages: {
                            hd: maybePageIndexToRest.currentPage,
                            tl: maybePageIndexToRest.priorPages
                          }
                        };
                } else {
                  return {
                          currentPage: undefined,
                          priorPages: /* [] */0
                        };
                }
              }));
}

function update(param, fn, map) {
  var attribute = param[1];
  var tabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(param[0]);
  return Belt_MapInt.update(map, tabId, (function (maybeTabConfig) {
                if (maybeTabConfig !== undefined) {
                  return {
                          currentPage: Belt_MapString.update(maybeTabConfig.currentPage, attribute, fn),
                          priorPages: maybeTabConfig.priorPages
                        };
                }
                var newConfig = Curry._1(fn, undefined);
                if (newConfig !== undefined) {
                  return {
                          currentPage: Belt_MapString.fromArray([[
                                  attribute,
                                  newConfig
                                ]]),
                          priorPages: /* [] */0
                        };
                }
                
              }));
}

function getInputIdentifierForCommand(command, commandIndex) {
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* NewWindowWithUrlCommand */1 :
    case /* NewTabWithUrlCommand */3 :
    case /* URLCommand */6 :
        return command._0.url;
    case /* ClickCommand */12 :
        return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* ClickInputCommand */13 :
        return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* TypeCommand */15 :
        return Curry._2(TypeCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
    case /* CheckboxCommand */16 :
        var match = command._0;
        if (match.TAG !== /* IndividualCheckOrUncheck */0) {
          return "input[type=checkbox][name='" + (match._0.name + "']");
        }
        var match$1 = match._0.interaction;
        var name = match$1.name;
        return name !== undefined ? "input[type=checkbox][name='" + (name + "']") : CheckboxCommand$SmartcutsMacros.getQuerySelectorForCheckboxIdAndNameAndValue(match$1.id, name, match$1.value);
    case /* SelectCommand */17 :
        return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* RadioCommand */18 :
        return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* MoveInputCursorCommand */22 :
        return Curry._2(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
    case /* MoveContentEditableCursorCommand */23 :
        return Curry._2(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, commandIndex, command._0);
    case /* CopyLinkAddressCommand */25 :
        return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* SelectionCommand */21 :
    case /* CopyCommand */24 :
    case /* CutCommand */26 :
        break;
    case /* PasteInInputCommand */27 :
        return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* DownloadCommand */32 :
        return String(command._0.chromeId);
    case /* GoogleSheetsCommand */33 :
        return Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
    case /* ContextMenuCommand */34 :
        return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* LoopCommand */35 :
        return LoopCommand$SmartcutsMacros.CommandValue.getIdentifier(command._0);
    case /* SwitchCommand */36 :
        return SwitchCommand$SmartcutsMacros.CommandValue.getIdentifier(command._0);
    case /* ScreenshotToClipboardCommand */37 :
        return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
    case /* ClickToOAuthCommand */40 :
        return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.getInputIdentifier, command._0);
    case /* UploadCommand */41 :
        return Curry._1(UploadCommand$SmartcutsMacros.CommandValue.Authoring.getIdentifier, command._0);
    case /* CopyImageSrcCommand */42 :
        return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.getInputIdentifier, command._0);
    case /* WithElementGroupsCommand */43 :
        return Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.getIdentifier, command._0);
    default:
      return ;
  }
  var match$2 = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(command._0.selection);
  return match$2[1];
}

function applyCommandWithContext(commandIndex, priorCommands, param, map) {
  var contextGlobal = param.contextGlobal;
  var tabRef = contextGlobal.tabRef;
  var command = param.command;
  var commandId = param.id;
  var mapWithMaybeNewPage;
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
      case /* ForwardCommand */1 :
      case /* BackCommand */2 :
          mapWithMaybeNewPage = registerNewPageForTab(tabRef.recordingId, map);
          break;
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowWithUrlCommand */1 :
      case /* NewTabWithUrlCommand */3 :
      case /* URLCommand */6 :
      case /* OpenedLinkCommand */7 :
      case /* SubmitFormCommand */8 :
      case /* SubmitFormRedirectCommand */9 :
      case /* ClientRedirectCommand */10 :
      case /* ServerRedirectCommand */11 :
          mapWithMaybeNewPage = registerNewPageForTab(tabRef.recordingId, map);
          break;
      default:
        mapWithMaybeNewPage = map;
    }
  }
  var identifier = getInputIdentifierForCommand(command, commandIndex);
  if (identifier !== undefined) {
    return update([
                tabRef.recordingId,
                identifier
              ], (function (maybeConfig) {
                  if (maybeConfig !== undefined) {
                    var commandValueConfigurability = maybeConfig.commandValueConfigurability;
                    return {
                            commandIndexes: {
                              hd: commandIndex,
                              tl: maybeConfig.commandIndexes
                            },
                            commandIds: {
                              hd: commandId,
                              tl: maybeConfig.commandIds
                            },
                            commandValueConfigurability: {
                              firstCommandIndex: commandValueConfigurability.firstCommandIndex,
                              otherCommandIndexes: {
                                hd: commandIndex,
                                tl: commandValueConfigurability.otherCommandIndexes
                              },
                              firstCommandId: commandValueConfigurability.firstCommandId,
                              otherCommandIds: {
                                hd: commandId,
                                tl: commandValueConfigurability.otherCommandIds
                              },
                              config: maybeUpdateConfigWithCommand(command, commandValueConfigurability.config)
                            }
                          };
                  }
                  var func = function (param, param$1) {
                    return maybeConfigFromCommand(priorCommands, param, param$1);
                  };
                  return Belt_Option.map(Curry._2(func, contextGlobal, command), (function (inputConfig) {
                                return {
                                        commandIndexes: {
                                          hd: commandIndex,
                                          tl: /* [] */0
                                        },
                                        commandIds: {
                                          hd: commandId,
                                          tl: /* [] */0
                                        },
                                        commandValueConfigurability: {
                                          firstCommandIndex: commandIndex,
                                          otherCommandIndexes: /* [] */0,
                                          firstCommandId: commandId,
                                          otherCommandIds: /* [] */0,
                                          config: inputConfig
                                        }
                                      };
                              }));
                }), mapWithMaybeNewPage);
  } else {
    return mapWithMaybeNewPage;
  }
}

function fromAuthoringCommandLog(commandLog) {
  return ListUtils$SmartcutsMacros.foldLefti(undefined, (function (commandIndex, commandWithContext, configByTabAndPageAndAttribute) {
                return applyCommandWithContext(commandIndex, Belt_Option.getWithDefault(Belt_List.take(commandLog, commandIndex), /* [] */0), commandWithContext, configByTabAndPageAndAttribute);
              }), commandLog);
}

function toSortedCommandValueConfigurabilities(map) {
  var flattenedConfigs = Belt_Array.concatMany($$Array.map((function (param) {
              return Belt_Array.concatMany($$Array.of_list(List.map(Belt_MapString.valuesToArray, {
                                  hd: param.currentPage,
                                  tl: param.priorPages
                                })));
            }), Belt_MapInt.valuesToArray(map)));
  return $$Array.of_list(List.map((function (param) {
                    return param.commandValueConfigurability;
                  }), ListUtils$SmartcutsMacros.sortBy((function (config) {
                        var arg = ListUtils$SmartcutsMacros.minimum(config.commandIndexes);
                        var param = "Expected commandIndexes to have length >= 1";
                        return OptionUtils$SmartcutsMacros.getExn(param, arg);
                      }), $$Array.to_list(flattenedConfigs))));
}

var ByTabAndPageAndInputIdentifier = {
  empty: undefined,
  registerNewPageForTab: registerNewPageForTab,
  update: update,
  getInputIdentifierForCommand: getInputIdentifierForCommand,
  applyCommandWithContext: applyCommandWithContext,
  fromAuthoringCommandLog: fromAuthoringCommandLog,
  toSortedCommandValueConfigurabilities: toSortedCommandValueConfigurabilities
};

function getMatchingCheckboxConfigurabilityForIndividualInteraction(singleCheckboxInteraction, commandValueConfigurabilities) {
  return Belt_Array.getBy(commandValueConfigurabilities, (function (param) {
                var config = param.config;
                if (config.TAG !== /* CheckboxConfig */3) {
                  return false;
                }
                var match = config._0.checkboxChoice;
                if (match.TAG === /* SingleCheckbox */0) {
                  return Curry._2(CheckboxCommand$SmartcutsMacros.CommandValue.SingleCheckboxInteraction.didInteractWithCheckboxOption, match._0, singleCheckboxInteraction);
                }
                var match$1 = match._0;
                var name = match$1.name;
                var doesNameMatch = Belt_Option.getWithDefault(Belt_Option.map(singleCheckboxInteraction.name, (function (name$p) {
                            return name$p === name;
                          })), false);
                if (doesNameMatch) {
                  return List.exists((function (checkboxOption) {
                                return Curry._2(CheckboxCommand$SmartcutsMacros.CommandValue.SingleCheckboxInteraction.didInteractWithCheckboxOption, checkboxOption, singleCheckboxInteraction);
                              }), match$1.options);
                } else {
                  return false;
                }
              }));
}

function getMatchingCheckboxConfigurabilityForMultipleInteraction(checkboxGroupWithChosenValues, commandValueConfigurabilities) {
  return Belt_Array.getBy(commandValueConfigurabilities, (function (param) {
                var config = param.config;
                if (config.TAG !== /* CheckboxConfig */3) {
                  return false;
                }
                var match = config._0.checkboxChoice;
                if (match.TAG === /* SingleCheckbox */0) {
                  return false;
                }
                var match$1 = match._0;
                var options = match$1.options;
                if (match$1.name === checkboxGroupWithChosenValues.name) {
                  return Belt_List.every(checkboxGroupWithChosenValues.checkedValues, (function (checkedValue) {
                                return List.exists((function (checkboxOption) {
                                              return checkedValue === checkboxOption.value;
                                            }), options);
                              }));
                } else {
                  return false;
                }
              }));
}

function getMatchingSelectConfigurabilityParams(locator, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* SelectInputConfig */4) {
                  return ;
                }
                var match = config._0;
                if (!Caml_obj.caml_equal(match.targetLocator, locator)) {
                  return ;
                }
                var allCommandIndexesActingOnThisInput = List.append(param.otherCommandIndexes, {
                      hd: param.firstCommandIndex,
                      tl: /* [] */0
                    });
                return [
                        match.dynamic,
                        allCommandIndexesActingOnThisInput
                      ];
              }), commandValueConfigurabilities);
}

function getMatchingRadioConfigurabilityParams(locator, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* RadioInputConfig */5) {
                  return ;
                }
                var match = config._0;
                if (!Caml_obj.caml_equal(match.targetLocator, locator)) {
                  return ;
                }
                var allCommandIndexesActingOnThisInput = List.append(param.otherCommandIndexes, {
                      hd: param.firstCommandIndex,
                      tl: /* [] */0
                    });
                return [
                        match.dynamic,
                        allCommandIndexesActingOnThisInput
                      ];
              }), commandValueConfigurabilities);
}

function getMatchingSelectionConfig(commandValue, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* SelectionConfig */9) {
                  return ;
                }
                var selectionConfig = config._0;
                if (SelectionRelatedCommands$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, selectionConfig)) {
                  return selectionConfig;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingCopyLinkAddressConfig(commandValue, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* CopyLinkAddressConfig */7) {
                  return ;
                }
                var copyLinkAddressConfig = config._0;
                if (CopyLinkAddressCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, copyLinkAddressConfig)) {
                  return copyLinkAddressConfig;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingCopyImageSrcConfig(commandId, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG === /* CopyImageSrcConfig */8 && commandId === param.firstCommandId) {
                  return config._0;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingMoveInputCursorConfig(commandValue, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* MoveInputCursorConfig */10) {
                  return ;
                }
                var cursorConfig = config._0;
                if (MoveInputCursorCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, cursorConfig)) {
                  return cursorConfig;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingMoveContentEditableCursorConfig(commandValue, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* MoveContentEditableCursorConfig */11) {
                  return ;
                }
                var cursorConfig = config._0;
                if (MoveContentEditableCursorCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, cursorConfig)) {
                  return cursorConfig;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingDownloadConfig(commandValue, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG !== /* DownloadConfig */12) {
                  return ;
                }
                var downloadConfig = config._0;
                if (DownloadCommand$SmartcutsMacros.AuthoringConfig.isForAuthoringCommandValue(commandValue, downloadConfig)) {
                  return downloadConfig;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingConfigForTypeCommand(commandId, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                var otherCommandIndexes = param.otherCommandIndexes;
                var firstCommandIndex = param.firstCommandIndex;
                switch (config.TAG | 0) {
                  case /* AddTextInputConfig */0 :
                      if (firstCommandIndex === commandId || List.mem(commandId, otherCommandIndexes)) {
                        return {
                                TAG: /* AddTextInputConfig */0,
                                _0: config._0
                              };
                      } else {
                        return ;
                      }
                  case /* DeleteTextInputConfig */1 :
                      if (firstCommandIndex === commandId || List.mem(commandId, otherCommandIndexes)) {
                        return {
                                TAG: /* DeleteTextInputConfig */1,
                                _0: config._0
                              };
                      } else {
                        return ;
                      }
                  default:
                    return ;
                }
              }), commandValueConfigurabilities);
}

function getMatchingInnerTextConfig(commandId, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG === /* InnerTextConfig */2 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
                  return config._0;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingClickInputConfig(commandId, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG === /* ClickInputConfig */14 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
                  return config._0;
                }
                
              }), commandValueConfigurabilities);
}

function getMatchingPasteInInputConfig(commandId, commandValueConfigurabilities) {
  return Util$SmartcutsMacros.shortcut((function (param) {
                var config = param.config;
                if (config.TAG === /* PasteInInputConfig */15 && (param.firstCommandIndex === commandId || List.mem(commandId, param.otherCommandIndexes))) {
                  return config._0;
                }
                
              }), commandValueConfigurabilities);
}

function mapDataRefInConfig(f, config) {
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        var addTextInputConfig = config._0;
        var originalLabeledAddText = addTextInputConfig.originalLabeledAddText;
        return {
                TAG: /* AddTextInputConfig */0,
                _0: {
                  targetLocator: addTextInputConfig.targetLocator,
                  originalLabeledAddText: {
                    label: originalLabeledAddText.label,
                    addText: Curry._1(f, originalLabeledAddText.addText)
                  },
                  selectedLabelIndex: addTextInputConfig.selectedLabelIndex,
                  playbackFormLabel: addTextInputConfig.playbackFormLabel,
                  strategy: addTextInputConfig.strategy
                }
              };
    case /* InnerTextConfig */2 :
        var match = config._0;
        return {
                TAG: /* InnerTextConfig */2,
                _0: {
                  intentionChoices: Belt_Array.map(match.intentionChoices, (function (param) {
                          return InnerTextSemantic$SmartcutsMacros.mapDataRef(f, param);
                        })),
                  chosen: InnerTextSemantic$SmartcutsMacros.mapDataRef(f, match.chosen)
                }
              };
    case /* GoogleSheetsConfig */13 :
        var func = GoogleSheetsCommand$SmartcutsMacros.AuthoringConfig.mapDataRef;
        return {
                TAG: /* GoogleSheetsConfig */13,
                _0: Curry._2(func, f, config._0)
              };
    case /* UploadConfig */17 :
        return {
                TAG: /* UploadConfig */17,
                _0: UploadCommand$SmartcutsMacros.AuthoringConfig.mapDataRef(config._0, f)
              };
    default:
      return config;
  }
}

exports.stringifyConfig = stringifyConfig;
exports.updateConfigWithPlaybackFormLabel = updateConfigWithPlaybackFormLabel;
exports.isDynamic = isDynamic;
exports.getAllCommandIndexes = getAllCommandIndexes;
exports.getLastCommandIndex = getLastCommandIndex;
exports.getAllCommandIndexesExceptLast = getAllCommandIndexesExceptLast;
exports.maybeConfigFromCommand = maybeConfigFromCommand;
exports.maybeUpdateConfigWithCommand = maybeUpdateConfigWithCommand;
exports.ByTabAndPageAndInputIdentifier = ByTabAndPageAndInputIdentifier;
exports.getMatchingCheckboxConfigurabilityForIndividualInteraction = getMatchingCheckboxConfigurabilityForIndividualInteraction;
exports.getMatchingCheckboxConfigurabilityForMultipleInteraction = getMatchingCheckboxConfigurabilityForMultipleInteraction;
exports.getMatchingSelectConfigurabilityParams = getMatchingSelectConfigurabilityParams;
exports.getMatchingRadioConfigurabilityParams = getMatchingRadioConfigurabilityParams;
exports.getMatchingSelectionConfig = getMatchingSelectionConfig;
exports.getMatchingCopyLinkAddressConfig = getMatchingCopyLinkAddressConfig;
exports.getMatchingCopyImageSrcConfig = getMatchingCopyImageSrcConfig;
exports.getMatchingMoveInputCursorConfig = getMatchingMoveInputCursorConfig;
exports.getMatchingMoveContentEditableCursorConfig = getMatchingMoveContentEditableCursorConfig;
exports.getMatchingDownloadConfig = getMatchingDownloadConfig;
exports.getMatchingConfigForTypeCommand = getMatchingConfigForTypeCommand;
exports.getMatchingInnerTextConfig = getMatchingInnerTextConfig;
exports.getMatchingClickInputConfig = getMatchingClickInputConfig;
exports.getMatchingPasteInInputConfig = getMatchingPasteInInputConfig;
exports.mapDataRefInConfig = mapDataRefInConfig;
/* Util-SmartcutsMacros Not a pure module */
